export enum TvhTransactionStatus {
  MONEY_DEPOSIT = 'MONEY_DEPOSIT',
  MONEY_DEPOSIT_BONUS = 'MONEY_DEPOSIT_BONUS',
  MACHINE_RESERVED = 'MACHINE_RESERVED',
  MACHINE_CANCELLED = 'MACHINE_CANCELLED',
  MACHINE_STARTED = 'MACHINE_STARTED',
}
